var map = {
	"./skin1/edit_face_no_highlight@3x.png": "a5a3",
	"./skin2/edit_face_no_highlight@3x.png": "14c9",
	"./skin3/edit_face_no_highlight@3x.png": "e543",
	"./skin4/edit_face_no_highlight@3x.png": "ec18",
	"./skin5/edit_face_no_highlight@3x.png": "a5e4",
	"./skin6/edit_face_no_highlight@3x.png": "82ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21de";